export const SOLD_TO_SHIP_TO_CHANGED = 'sold-to-ship-to/changed';
